import React, { useState, useEffect } from "react";
import RoundedTable, {
  TABLE_CELL_TYPES,
} from "../../components/table-component/RoundedTable";
import CustomButton from "../../components/CustomButton";
import CustomInput from "../../components/CustomInput";
import PageWrapper from "../../components/PageWrapper";
const INVENTORY_KEY = "inventory_data"; // LocalStorage Key

const CashierSystem = () => {
  const [inventory, setInventory] = useState([]);
  const [cart, setCart] = useState([]);
  const [newItem, setNewItem] = useState({
    id: "",
    name: "",
    cost: "",
    price: "",
    amount: "",
  });
  const [scannedCode, setScannedCode] = useState(""); // State for scanned barcode
  const [isProductsVisible, setIsProductsVisible] = useState(false); // State for toggling visibility of product list

  // Load inventory from localStorage when the component mounts
  useEffect(() => {
    const savedInventory = JSON.parse(localStorage.getItem(INVENTORY_KEY));
    if (savedInventory) {
      setInventory(savedInventory);
    }
  }, []);

  // Save inventory to localStorage when it changes
  useEffect(() => {
    localStorage.setItem(INVENTORY_KEY, JSON.stringify(inventory));
  }, [inventory]);

  // Handle input change for inventory item
  const handleInputChange = (e) => {
    setNewItem({ ...newItem, [e.target.name]: e.target.value });
  };

  // Add item to inventory
  const addToInventory = () => {
    if (!newItem.id || !newItem.name || !newItem.price || !newItem.amount) {
      alert("Please fill all fields!");
      return;
    }

    // Ensure cost and price are parsed as numbers
    const parsedCost = parseFloat(newItem.cost);
    const parsedPrice = parseFloat(newItem.price);

    // Check if parsed values are valid numbers
    if (isNaN(parsedCost) || isNaN(parsedPrice)) {
      alert("Please enter valid numbers for cost and price.");
      return;
    }

    // Add new item to inventory
    const updatedInventory = [
      ...inventory,
      {
        ...newItem,
        cost: parsedCost,
        price: parsedPrice,
        amount: parseInt(newItem.amount), // Ensure amount is stored as an integer
      },
    ];

    // Update inventory state
    setInventory(updatedInventory);

    // Reset input fields
    setNewItem({ id: "", name: "", cost: "", price: "", amount: "" });
  };

  // Handle scan when barcode is detected
  const handleScan = (scannedCode) => {
    const inventoryItem = inventory.find((item) => item.id === scannedCode);

    if (!inventoryItem) {
      alert("Item not found in inventory!");
      return;
    }

    const existingItem = cart.find((item) => item.id === scannedCode);

    if (existingItem) {
      setCart(
        cart.map((item) =>
          item.id === scannedCode
            ? { ...item, quantity: item.quantity + 1 }
            : item
        )
      );
    } else {
      setCart([...cart, { ...inventoryItem, quantity: 1 }]);
    }
  };

  // Inventory Table
  const inventoryTable = {
    titles: [
      { value: "ID" },
      { value: "Name" },
      { value: "Cost" },
      { value: "Price" },
      { value: "Amount" },
    ],
    rows: inventory.map((item) => [
      { value: item.id, type: TABLE_CELL_TYPES.TEXT },
      { value: item.name, type: TABLE_CELL_TYPES.TEXT },
      { value: `$${item.cost}`, type: TABLE_CELL_TYPES.TEXT },
      { value: `$${item.price}`, type: TABLE_CELL_TYPES.TEXT },
      { value: item.amount, type: TABLE_CELL_TYPES.TEXT },
    ]),
  };

  // Cart Table
  const cartTable = {
    titles: [
      { value: "ID" },
      { value: "Name" },
      { value: "Price" },
      { value: "Quantity" },
    ],
    rows: cart.map((item) => [
      { value: item.id, type: TABLE_CELL_TYPES.TEXT },
      { value: item.name, type: TABLE_CELL_TYPES.TEXT },
      { value: `$${item.price}`, type: TABLE_CELL_TYPES.TEXT },
      { value: item.quantity, type: TABLE_CELL_TYPES.TEXT },
    ]),
  };

  return (
    <PageWrapper>
      <div className="o-column o-column--gap-size_300 u-padding--bottom_500">
        <h2>📦 Inventory Management</h2>
        <div className="o-column o-column--gap-size_100 u-padding--bottom_500">
          <div className="o-row o-row--gap-size_300 u-padding--bottom_500">
            <CustomInput
              type="text"
              name="id"
              placeholder="Barcode"
              value={newItem.id}
              onChange={handleInputChange}
            />
            <CustomInput
              type="text"
              name="name"
              placeholder="Name"
              value={newItem.name}
              onChange={handleInputChange}
            />
            <CustomInput
              type="number"
              name="cost"
              placeholder="Cost on me"
              value={newItem.cost}
              onChange={handleInputChange}
            />
            <CustomInput
              type="number"
              name="price"
              placeholder="Selling Price"
              value={newItem.price}
              onChange={handleInputChange}
            />
            <CustomInput
              type="number"
              name="amount"
              placeholder="Amount in Store"
              value={newItem.amount}
              onChange={handleInputChange}
            />
          </div>
          <CustomButton title="Add to Inventory" onClick={addToInventory} />
        </div>
        {/* CustomButton for Show/Hide Products Toggle */}
        <div className="toggle-products">
          <CustomButton
            variant="blank"
            title={isProductsVisible ? "Hide Products ▲" : "Show Products ▼"}
            onClick={() => setIsProductsVisible(!isProductsVisible)}
          />
        </div>
        {/* Conditionally render the Inventory Table */}
        {isProductsVisible && <RoundedTable {...inventoryTable} />}
        UNTIL HERE
        <h2>🛒 Cashier System</h2>
        {/* Barcode scanning input field */}
        <CustomInput
          type="text"
          placeholder="Scan Barcode"
          value={scannedCode}
          onChange={(e) => setScannedCode(e.target.value)} // Update scanned barcode on change
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleScan(scannedCode); // Trigger scan when "Enter" is pressed
              setScannedCode(""); // Clear input field after scanning
            }
          }}
        />
        <RoundedTable {...cartTable} />
      </div>
    </PageWrapper>
  );
};

export default CashierSystem;
